import React, { useState } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import context from '@/context'
import { DropDownList } from '@/components/dropDownList'

function AddUserRoleDialog (props) {
  const [roleId, setRoleId] = useState(null)

  function handleConfirm () {
    props.onAction(roleId)
  }

  return (
    <ValidationBoundary>
      <BasicHeader title={props.content.internal ? 'UsersManagement.AddInternalRole' : 'UsersManagement.AddExternalRole'} {...props} />
      <ModalBody>
        <Validator name='role' value={roleId} required>
          <DropDownList
            dataSource={(req) => props.content.internal ? context.api.userManagementService.getInternalRoles(req) : context.api.userManagementService.getExternalRoles(req)}
            textField='displayName'
            onChange={({ value }) => setRoleId(value)}
            value={roleId} />
        </Validator>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...props} onAction={handleConfirm} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: AddUserRoleDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/addUserRole.js